import React, { useEffect, useState } from 'react';
import { Framework } from '../../types/framework';
import ListViewWithModal from '../Common/ListViewWithModal';
import { useFrameworks } from '../../hooks/useToolboxHooks';
import { useAddCustomerComplianceMutation, useDeleteCustomerComplianceMutation, useFetchCustomerCompliances } from '../../hooks/customer-hooks';
import { CustomerCompliance as CustomerComplianceFramework } from '../../types/customer';


interface CustomerComplianceProps {
  customerID: string | number;
}

const CustomerCompliance: React.FC<CustomerComplianceProps> = ({ customerID }) => {
  const { frameworks, lookup, loading, error } = useFrameworks();
  const { data: customerComplianceEntries } = useFetchCustomerCompliances({customer: customerID as string }, { enabled: !!customerID });
  const [customerFrameworks, setCustomerFrameworks] = useState<(Framework & { customerEntry?: number })[]>([]);
  const { mutate: addCustomerFramework } = useAddCustomerComplianceMutation();
  const { mutate: deleteCustomerFramework } = useDeleteCustomerComplianceMutation();

  useEffect(() => {
    if (!customerComplianceEntries?.length || !frameworks?.length) {
      setCustomerFrameworks([]);
      return;
    }

    for (const entry of customerComplianceEntries) {
      const filteredFrameworks = customerComplianceEntries.map((f: CustomerComplianceFramework) => ({ ...lookup[f.framework] as Framework, customerEntry: f.id }))
      setCustomerFrameworks(filteredFrameworks);
    }
  }, [frameworks, customerComplianceEntries, lookup]);

  if (loading) return <div>Loading frameworks...</div>;
  if (error) return <div>Error loading frameworks: {error}</div>;

  return (
    <ListViewWithModal<Framework & { customerEntry?: number }>
      title="Compliance Frameworks"
      items={customerFrameworks}
      availableItems={frameworks}
      onAddItem={(item) => addCustomerFramework({ customer: customerID as string, framework: item.id })}
      onDeleteItem={(id) => deleteCustomerFramework({ customer: customerID as string, id: customerFrameworks.find(f => f.id.toString() === id)?.customerEntry })}
      idKey="id"
      nameKey="name"
      descriptionKey="description"
    />
  );
};

export default CustomerCompliance;